import { useEffect, useState, useCallback } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import Input from 'components/input/input';
import Select from 'components/select/select';

import { ReactComponent as ArrowRightSVG } from 'icons/arrow-right.svg';

import { getPsadRepById, updatePsadRep } from 'api/psad_reps';
import { getAllTreatingOrgs } from 'api/treating_orgs';

const PsadRepsEdit = () => {
  const [loading, setLoading] = useState(false);
  const [allTreatingOrgs, setAllTreatingOrgs] = useState([]);
  const [psadRep, setPsadRep] = useState(null);
  const [treatingOrg, setTreatingOrg] = useState(null);
  const { id } = useParams();
  const history = useHistory();
  const [validation, setValidation] = useState({
    firstName: true,
    lastName: true,
    email: true,
    treatingOrg: true,
  });

  useEffect(() => {
    (async () => {
      const allTreatingOrgs = await getAllTreatingOrgs();

      setAllTreatingOrgs(
        allTreatingOrgs.map((t) => ({
          id: t.id,
          value: t.id,
          label: t.name,
        })),
      );
    })();
  }, []);

  const fetchData = useCallback(async () => {
    setLoading(true);
    const data = await getPsadRepById(id);
    setPsadRep(data);
    setTreatingOrg(
      data.treatingOrg
        ? {
            id: data.treatingOrg.id,
            value: data.treatingOrg.id,
            label: data.treatingOrg.name,
          }
        : null,
    );
    setLoading(false);
  }, [id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const onChange = (e) => {
    const { name, value } = e.target;

    setPsadRep({
      ...psadRep,
      [name]: value,
    });
  };

  const onSelectChange = (selectedOption) => setTreatingOrg(selectedOption);

  const checkValidity = () => {
    const validation = {
      firstName: !!psadRep.firstName,
      lastName: !!psadRep.lastName,
      email: !!psadRep.email,
      treatingOrg: !!treatingOrg,
    };

    setValidation(validation);

    return Object.values(validation).every(Boolean);
  };

  const onSubmit = async () => {
    const isValid = checkValidity();

    if (isValid) {
      setLoading(true);
      const newPsadRep = await updatePsadRep({
        ...psadRep,
        treatingOrg: treatingOrg?.id,
      });

      setPsadRep(newPsadRep);
      setLoading(false);
      history.goBack();
    }
  };

  if (loading || !psadRep) return <main className="th-main"></main>;

  return (
    <main className="th-main">
      <section className="th-canvas">
        <header className="th-canvas-header post-header">
          <h2 className="th-canvas-title">
            <span className="pointer" onClick={() => history.goBack()}>
              Go Back
            </span>
            <span>
              <ArrowRightSVG />
            </span>
            {psadRep.firstName} {psadRep.lastName}
          </h2>
          <section className="view-actions">
            <button className="btn-green" data-cy="submit" onClick={onSubmit}>
              <span>Save</span>
            </button>
          </section>
        </header>
        <div>
          <h4 className="midlightgrey f-small fw5 ttu mt15">Details</h4>
          <div className="pa5 pt4 br4 shadow-1 bg-grouped-table mt2 flex flex-column items-start justify-between">
            <div className="w-100 flex flex-column">
              <div className="w-100 flex flex-row items-start justify-between margin-between">
                <div className="w-100">
                  <div className="w-100 flex flex-row justify-between margin-between">
                    <div className="w-50">
                      <Input
                        name="firstName"
                        label="First name*"
                        value={psadRep.firstName}
                        valid={validation.firstName}
                        onChange={onChange}
                      />
                    </div>
                    <div className="w-50">
                      <Input
                        name="lastName"
                        label="Last name*"
                        value={psadRep.lastName}
                        valid={validation.lastName}
                        onChange={onChange}
                      />
                    </div>
                  </div>
                  <div className="w-100 flex flex-row justify-between margin-between">
                    <div className="w-50">
                      <Input
                        name="email"
                        label="Email*"
                        value={psadRep.email}
                        valid={validation.email}
                        onChange={onChange}
                      />
                    </div>
                    <div className="w-50">
                      <Input
                        name="phone"
                        label="Phone number"
                        value={psadRep.phone}
                        valid={true}
                        onChange={onChange}
                      />
                    </div>
                  </div>
                  <div className="w-100 flex flex-row justify-between margin-between">
                    <div className="w-100">
                      <Select
                        className="treating-org-select"
                        valid={validation.treatingOrg}
                        isMulti={false}
                        label="Treating organisation*"
                        value={treatingOrg}
                        options={allTreatingOrgs}
                        onChange={onSelectChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default PsadRepsEdit;
